var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchCharcoalGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6849 6.671C14.6849 2.98704 11.3974 0 7.34249 0C3.28771 0 0 2.98704 0 6.671C0 10.355 3.28771 13.3419 7.34249 13.3419C11.3974 13.3419 14.6849 10.355 14.6849 6.671ZM7.34249 11.6741C4.30582 11.6741 1.83567 9.43 1.83567 6.67104C1.83567 3.91208 4.30582 1.66783 7.34249 1.66783C10.3791 1.66783 12.8494 3.91208 12.8494 6.67104C12.8494 9.43 10.3791 11.6741 7.34249 11.6741Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4668 15.1557L14.1604 12.1514C13.5303 11.5789 12.5557 11.6832 11.937 12.268C11.2411 12.9258 11.1001 14.0877 11.8088 14.7316L14.8712 17.5139C15.5884 18.1653 16.7511 18.1653 17.4668 17.5139C18.184 16.8635 18.184 15.8071 17.4668 15.1557Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCharcoalGrey);
export default __webpack_public_path__ + "static/media/search-charcoal-grey.fbc7397410b7671b89ce39650a54af53.svg";
export { ForwardRef as ReactComponent };